import Styled, { keyframes, css } from 'styled-components';

import {
  maxWidth,
  tablet,
  desktop,
  mobileMaxWidth,
} from '../utils/constants';

export const FlooringContainer = Styled.div`
  max-width: ${maxWidth};
  background-color: #f5f5f5;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  font-family: 'Helvetica';

  @media all and (max-width: ${tablet}) {
    padding: 1rem;
  }
`;

export const FlooringWrapper = Styled.div`
  width: 100%;
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  align-items: stretch;

  & > div {
    @media all and (min-width: ${desktop}){
      &:first-child {
        padding-right: 1rem;
      }
    }
  }

  @media all and (max-width: ${tablet}){
    width: 100%
  }
`;

export const ConfiguratorContainer = Styled.div`
  flex: 1 0 100%;
  max-width: 100%;
  color: #333;
  
  max-width: 100%;

  & > div {
    &:nth-child(1) {
      display: block;
    }

    &:nth-child(2) {
      display: block;
    }
    display: 'block')};
  }

  &.loading {
    display: none;
  }

  @media all and (min-width: ${desktop}) {
    flex: 1 0 70%;
    max-width: 70%;
  }
`;
export const SummaryContainer = Styled.div`
  flex: 1 0 100%;
  max-width: 100%;
  color: #333;
  font-size: 2.4rem;

  &.loading {
    display: none;
  }

  @media all and (min-width: ${desktop}) {
    max-width: 30%;
    flex: 1 0 30%;
  }
`;

export const BreadCrumbContainer = Styled.div`
  padding: 1rem;
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
  font-size: 1.6rem;
`;

const fadeOutAnimation = keyframes`
    from {
      opacity: 1
    }
    70% {opacity: 1}
    to {
      opacity: 0
    }
    `;

export const BannerMessage = Styled.div`
  flex-grow: 1;
  @media all and (max-width: 1024px) {
    display: block;
    line-height: 2.8rem;
    font-size: 1.6rem;
  }
  `;

export const BannerWrapper = Styled.div`
  position: absolute;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  background: #3E7697;
  font-family: 'helvetica-neue';
  font-size: 1.8rem;
  color: white;
  overflow: visible;
  width: calc(100vw - 20px);
  max-width: 1420px;
  z-index: 9;
  ${({ hasTimer }) => (hasTimer && css`animation: ${fadeOutAnimation} 10s linear;`)}  
  @media all and (max-width: 1024px) {
    align-items: flex-start;
  }
`;
